import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107104Status: 'idle',
    startProcess107104Error: undefined as any,
    loadUserParamsProcess107104Status: 'idle',
    loadUserParamsProcess107104Error: undefined as any,

    process107104List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107104 = createAsyncThunk('process107104Slice/startProcess107104', async ({ process107104 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107104/`,
        prepareData(process107104),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107104Status } = getState().process107104Slice
        return startProcess107104Status !== 'pending'
    }
})

export const loadUserParamsProcess107104 = createAsyncThunk('process107104Slice/loadUserParamsProcess107104', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107104/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107104Status } = getState().process107104Slice
        return loadUserParamsProcess107104Status !== 'pending'
    }
})

const Process107104Slice = createSlice({
    name: 'process107104Slice',
    initialState,
    reducers: {
        resetstartProcess107104: (state) => {
            state.job = undefined
            state.startProcess107104Error = undefined
        },
        resetstartProcess107104Error: (state) => {
            state.startProcess107104Error = undefined
        },
        resetloadUserParamsProcess107104: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107104Error = undefined
        },
        resetloadUserParamsProcess107104Error: (state) => {
            state.loadUserParamsProcess107104Error = undefined
        },
        removeFromProcess107104ListById: (state, action) => {
            state.process107104List = state.process107104List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107104ListByIds: (state, action) => {
            state.process107104List = state.process107104List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107104List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107104Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107104List = []
            state.startProcess107104Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107104.pending, (state) => {
            state.startProcess107104Status = 'pending'
            state.startProcess107104Error = undefined
        })
        builder.addCase(startProcess107104.fulfilled, (state, action) => {
            state.startProcess107104Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107104.rejected, (state, action) => {
            state.startProcess107104Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107104Error = action.error.message
            } else {
                state.startProcess107104Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107104.pending, (state) => {
            state.loadUserParamsProcess107104Status = 'pending'
            state.loadUserParamsProcess107104Error = undefined
        })
        builder.addCase(loadUserParamsProcess107104.fulfilled, (state, action) => {
            state.loadUserParamsProcess107104Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107104.rejected, (state, action) => {
            state.loadUserParamsProcess107104Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107104Error = action.error.message
            } else {
                state.loadUserParamsProcess107104Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107104,
    resetstartProcess107104Error,
    resetloadUserParamsProcess107104,
    resetloadUserParamsProcess107104Error,
    removeFromProcess107104ListById,
    removeFromProcess107104ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107104Slice.actions
export default Process107104Slice.reducer
